import { useEffect, useState } from 'react';
import { LARAVEL_BASE } from '../config';
import { fetchUser } from '../authSession';

export default function Private({ children }) {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        let timer;
        (async () => {
        const ok = await pingAuth();
        if (!ok) return;
        setReady(true);
        // keep-alive ทุก 5 นาที (AuthController@me ทำ sliding อยู่แล้ว)
        timer = setInterval(() => { pingAuth(); }, 5 * 60 * 1000);
        })();
        return () => clearInterval(timer);
    }, []);

    function normalizedUrl() {
        const u = new URL(window.location.href);
        if (u.hostname === 'localhost') u.hostname = '127.0.0.1';
        return u.toString();
    }

    async function pingAuth() {
        try {
        const res = await fetch(`${LARAVEL_BASE}/auth/me`, { credentials: 'include' });
        if (res.ok) { await res.clone().json().then(() => fetchUser()); return true; }
        if (res.status === 401) {
            const ret = encodeURIComponent(normalizedUrl());
            window.location.href = `${LARAVEL_BASE}/center-login?returnUrl=${ret}`;
            return false;
        }
        const ret = encodeURIComponent(normalizedUrl());
        window.location.href = `${LARAVEL_BASE}/center-login?returnUrl=${ret}`;
        return false;
        } catch {
        const ret = encodeURIComponent(normalizedUrl());
        window.location.href = `${LARAVEL_BASE}/center-login?returnUrl=${ret}`;
        return false;
        }
    }

    if (!ready) return null;
    return children;
}
